// extracted by mini-css-extract-plugin
module.exports = {"date":"TourListTableItem_date__3wEOc","address":"TourListTableItem_address__2CM3P","link":"TourListTableItem_link__PR4fB","detach":"TourListTableItem_detach__2wvsr"};